var $class="se2--content-blocks-grid",$name="ContentBlocksGrid",$path="app/components/ContentBlocksGrid/index.js",$this={$class,$name,$path,};import gsap from 'gsap';
import lazyHandleOpenModalButtons from 'app/components/utilities/lazyHandleOpenModalButtons';

import shell from 'app/modules/shell';

import 'app/partials/image';
import './partials/cards';
import isDesktopBreakpoint from 'app/utilities/isDesktopBreakpoint';

export default shell.registerComponent($this, ({ addEventListener, mount }) => {
  mount((element) => {
    const cardWrapperSelector = '.card-wrapper';
    const componentWithoutCtaClassName = 'without-cta';
    const cardsWrapperElements = element.querySelectorAll(cardWrapperSelector);

    const hover = (card) => gsap.to(card, {
      scaleX: 1.05,
      scaleY: 1.05,
      duration: 0.3,
      paused: true,
      ease: 'ease-in-out',
    });

    cardsWrapperElements.forEach((card) => {
      if (card.classList.contains(componentWithoutCtaClassName)) return;
      const animation = hover(card);

      addEventListener(card, 'mouseenter', () => isDesktopBreakpoint() && animation.play());
      addEventListener(card, 'mouseleave', () => isDesktopBreakpoint() && animation.reverse());
    });

    lazyHandleOpenModalButtons(addEventListener, element);
  });
});
